import { apiClient } from "../api";
import { Model_Login } from "./types/auth";

export const login = (data: Model_Login) => {
  const ac = apiClient()
  const promise = ac.post('/token/', data)
    .then(res => {
      return res.data
    })
  return promise
}
